export const azureConfig = {
    storageAccountName: 'realtyspace',
    containerName: 'images',
    sasToken: 'sp=rcw&st=2025-07-17T01:51:19Z&se=2028-10-31T10:06:19Z&spr=https&sv=2024-11-04&sr=c&sig=t%2Fm87%2B3LFkOABXIgKtOy83GifyehZV0qVa4grP80HIY%3D',
  };